// @flow
import React, { type Node } from 'react';

import {
  ProductFeatureCard,
  type ProductFeatureCardProps,
} from 'Components/widgets/product-feature-card/ProductFeatureCard.jsx';
import { ProductInformationSliderContainer } from 'Components/widgets/product-information-slider/ProductInformationSlider.container.jsx';

type Props = {
  items: Array<ProductFeatureCardProps>,
  renderDetail: (data: *) => Node,
};

export function ProductFeaturesSlider(props: Props) {
  const { items, ...rest } = props;

  return (
    <ProductInformationSliderContainer {...rest}>
      {items.map(item => (
        <ProductFeatureCard key={item.title} {...item} />
      ))}
    </ProductInformationSliderContainer>
  );
}
